module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("knwVt"))).then(() => parcelRequire('iDabs'));